import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorMessage } from '../models/errorMessage.model';
import { ErrorMessageDialogComponent } from '../errorMessageDialog.component';

@Injectable({
  providedIn: 'root'
})

export class ErrorMessageService {

    closeFunction: any;

    constructor(
        public dialog: MatDialog
    ) { }
  
    displayDialog({ errorMessage }: { errorMessage: ErrorMessage }): void {
        this.dialog.open(ErrorMessageDialogComponent, {
            width: errorMessage.width ? errorMessage.width : '60wv',
            data: { model: errorMessage },
        }).afterClosed().subscribe(result => this.close());
    }
  
    private close(): void {
        // this.closeFunction();
    }
}
